import { render, staticRenderFns } from "./TransferSegment.vue?vue&type=template&id=4d4224a0&scoped=true"
import script from "./TransferSegment.vue?vue&type=script&lang=js"
export * from "./TransferSegment.vue?vue&type=script&lang=js"
import style0 from "./TransferSegment.vue?vue&type=style&index=0&id=4d4224a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4224a0",
  null
  
)

export default component.exports